import * as React from 'react';
import {FunctionComponent} from 'react';
import {HeatmapLayer} from "@react-google-maps/api";
import Loading from "../../loading/Loading";
import {Stat} from "../../../repositories/stat/Stat";
import {AccessPoint} from "../../../repositories/accesspoint/AccessPoint";
import useAccessPointListenerHook from "../../../hooks/UseAccessPointListener.hook";
import useStatListenerHook from "../../../hooks/UseStatListener.hook";
import useConfigListenerHook from '../../../hooks/ConfigListener.hook';
import { Config } from '../../../repositories/config/Config';

interface HeatMapProps {

}

const HeatMap: FunctionComponent<HeatMapProps> = () => {
    const stats: Stat[] = useStatListenerHook();
    const accessPoints: AccessPoint[] = useAccessPointListenerHook();
    const config: Config = useConfigListenerHook();

    if (!stats || stats.length === 0 || !accessPoints || accessPoints.length === 0)
        return <Loading loading={true}/>;

    const data: google.maps.visualization.WeightedLocation[] = stats
        .map((stat: Stat) => {
            const accessPoint = accessPoints.find((accessPoint) => accessPoint.id === stat.id)
            return ({
                location: new google.maps.LatLng(accessPoint?.cords.lat || 0, accessPoint?.cords.long || 0),
                weight: stat.connected
            })
        })
        .filter((item) => item.location.lat() !== 0 && item.location.lng() !== 0);

    const connections = stats.map(stat => stat.connected);
    const max = Math.max(...connections, config.heatmap_min_max_intensity);

    return (
        <HeatmapLayer
            data={data}
            options={{
                data,
                radius: config.heatmap_radius,
                dissipating: true,
                maxIntensity: max,
            }}
        />
    );
};

export default HeatMap;
